import React, { useRef, useState } from 'react';
import {
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  Datagrid,
} from 'react-admin';

import { Card, makeStyles } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PERMISSAO_TELA_SETORES_LISTAR } from '../../utils/dadosTelas';
import DialogoCreateEdit from './DialogoCreateEdit';
import DialogoDeleteResource from './DialogoDeletar';
//import ActionsField from './Fields/ActionsField';

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    // backgroundColor: '#f8f8f8',
    padding: '10px',
    // color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    // borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));
//
const MyList = ({ ...props }) => {
  const refDialogoCompra = useRef(null);
  const refDialogoDeleteResource = useRef(null);
  const refresh = useRefresh();
  const classes = useStyles();
  const [dialogo, setDialogo] = useState({
    open: false,
    id: null,
  });

  function handleCriar() {
    /* if (refDialogoCompra.current) {
      refDialogoCompra.current.handleCreate();
    } */
    setDialogo({
      open: true,
      id: null,
    });
  }
  function handleEdit({ id }) {
    /* if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    } */
    setDialogo({
      open: true,
      id,
    });
  }
  function deleteHundle({ id }) {
    if (refDialogoDeleteResource.current)
      refDialogoDeleteResource.current.handleOpen(id);
  }

  const handleClose = () => {
    refresh();
    setDialogo({
      open: false,
      id: null,
    });
  };

  return (
    <>
      <Title title="Versões" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <TextField
            source="nome"
            label="Nome"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <TextField
            source="codigo_teclado"
            label="Código Teclado"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ActionsField
            source="valor"
            textAlign="right"
            label="Ações"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            /*      handleDelete={deleteHundle}
            handleEdit={handleEdit}
            ativo */
            actions={[
              {
                title: 'Editar',
                icon: <EditOutlinedIcon />,
                show: () => true,
                disabled: (record) => record.gerenciado,
                onClick: (record) => handleEdit(record),
              },
              {
                title: 'Deletar',
                icon: <DeleteOutlineIcon />,
                show: () => true,
                disabled: (record) => record.gerenciado,
                onClick: (record) => deleteHundle(record),
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <DialogoCreateEdit
        open={dialogo.open}
        id={dialogo.id}
        onClose={() => {
          setDialogo({
            open: false,
            id: null,
          });
          handleClose();
        }}
        isDialogoConfirmacaoActions
      />
      {/* <Dialogo ref={refDialogoCompra} handleClose={handleClose} /> */}
      <DialogoDeleteResource
        ref={refDialogoDeleteResource}
        handleClose={handleClose}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_SETORES_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      title="Setores de balanças"
      component="div"
    />
  </ProtegerPagina>
);

export default List2;
